
import React from 'react';
import { Button } from '@material-ui/core';
import { withStyles, Theme } from '@material-ui/core/styles';

const styles: any = (theme: Theme) => ({
  root: {
    color: '#FFF',
    padding: '13px 36px',
    backgroundColor: '#00ABCA',
    border: 'none',
    borderRadius:10,
    fontFamily:'Roboto',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#0095b1'
    },
    [theme.breakpoints.down('md')]: {
      padding: '10px 20px',
    },
  },
  secondary: {
    color: '#00ABCA',
    padding: '13px 36px 13px 36px',
    textTransform: 'none',
    backgroundColor: '#F4F7FC',
    border: 'none',
    fontFamily:'Roboto',
    boxShadow: 'none',
    borderRadius:10,
    '&:hover': {
      backgroundColor: '#F4F7FC'
    }
  },
  link: {
    color: '#00adcc',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
})



interface ActionButtonProps {
  loading?: boolean;
  size?: 'small' | 'medium' | 'large' | undefined;
  type?: string;
  fullWidth?: boolean;
  textOnly?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  style?: any;
  onClick(): void;
}

const ActionButton = (props: ActionButtonProps) => {
  const { classes }: any = props

  let className: any = classes.root;
  if (props.type && props.type === 'secondary') {
    className = classes.secondary;
  }

  return (
    <Button 
      variant="contained" 
      color="primary" 
      className={className} 
      fullWidth={(props.fullWidth !== undefined ? props.fullWidth : false)} 
      onClick={props.onClick}
      disabled={(props.disabled !== undefined ? props.disabled : false)} 
      style={props.style}
    >
      {props.children}
    </Button>
  )
};

export default withStyles(styles)(ActionButton);



// WEBPACK FOOTER //
// ./src/components/buttonsComponent/ActionButton.tsx